audio,
video {
  border-radius: inherit;
  vertical-align: middle;
  width: 100%;
  outline: 0;
}

video {
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  height: 100%;
  user-select: none;
}
